import { api } from "./api";

export interface FeedInventoryRow {
  date: string;
  raw_material_id: number;
  raw_material_name: string;
  unit: string;
  opening_stock: number;
  purchases: number;
  adjustments: number;
  consumption: number;
  closing_stock: number;
}

export interface FeedInventoryReport {
  materials: string[];
  rows: FeedInventoryRow[];
}

export const feedInventoryReportService = {
  getReport: (from?: string, to?: string): Promise<FeedInventoryReport> => {
    const params = new URLSearchParams();
    if (from) params.set("from", from);
    if (to) params.set("to", to);
    const qs = params.toString();
    return api
      .get(`/reports/feed-inventory${qs ? `?${qs}` : ""}`)
      .then((r) => r.data as FeedInventoryReport);
  },
};
